import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Drawer, Table } from "antd";
import { t } from "i18next";
import { PaperClipOutlined } from "@ant-design/icons";
import moment from "moment";
import { getHistorySalaryScale } from "services/salary_scale_record";
import { getHostURl } from "services/core";


function HistoryDrawer(_, ref) {
   const [visible, setVisible] = useState(false);
   const [histories, setHistories] = useState([]);
   const [id, setId] = useState(null);
   const [loading, setLoading] = useState(false);

   useImperativeHandle(ref, () => {
      return {
         showHistoryDrawer(salaryScaleId) {
            setVisible(true)
            setLoading(true);
            setId(salaryScaleId);
            getHistorySalaryScale(salaryScaleId)
               .then((response) => {
                  if (response?.data?.data) {
                     const data = response.data.data;
                     setHistories(data)
                  }
               })
               .finally(() => setLoading(false));
         }
      };
   }, []);

   const onClose = () => {
      setVisible(false)
      setLoading(false);
   }

   return (
      <Drawer
         title={"History Salary Scale Record"}
         placement="right"
         closable={true}
         onClose={onClose}
         visible={visible}
         width={1350}
      >
         <div className="data-table">
            <Table
               rowKey={(record) => `${record.id}`}
               columns={[
                  {
                     title: t("text_job_level"),
                     key: "jobLevel",
                     dataIndex: "jobLevel",
                  },
                  {
                     title: t("text_job_grade"),
                     key: "jobGrade",
                     dataIndex: "jobGrade",
                     width: 110
                  },
                  {
                     title: t("text_scale_level"),
                     key: "scaleLevel",
                     dataIndex: "scaleLevel",

                  },
                  {
                     title: t("text_scale_column"),
                     key: "scaleColumn",
                     dataIndex: "scaleColumn",
                  },
                  {
                     title: t("text_history_before"),
                     key: "previousValue",
                     dataIndex: "previousValue",
                     width: 90
                  },
                  {
                     title: t("text_history_current"),
                     key: "currentValue",
                     dataIndex: "currentValue",
                     width: 90
                  },
                  {
                     title: t("text_attachment"),
                     key: "attachment",
                     dataIndex: "attachment",
                     render: (attachment) => <a target="_blank" rel="noopener noreferrer" key="1" href={`${getHostURl()}/public/uploads/salary_scale/${id}/${attachment}`}><PaperClipOutlined /><span> {attachment}</span></a>,
                  },
                  {
                     title: t("text_modified_by"),
                     key: "user",
                     dataIndex: "user",
                  },
                  {
                     title: t("text_modified_at"),
                     key: "date",
                     dataIndex: "date",
                     render: (date) => date && moment(date).format("DD/MM/YYYY"),
                     width: 120
                  },
               ]}
               loading={loading}
               pagination={false}
               scroll={histories.length > 10 ? { y: 775 } : {}}
               dataSource={histories}
            />
         </div>
      </Drawer>
   )
}

export default forwardRef(HistoryDrawer);
